import { useQueries } from "@tanstack/react-query";
import Hls from "hls.js";
import { uniq } from "lodash/fp";

import { getRecordingInfo } from "@app/analytics/api/meetingReport";
import { UnauthorizedVideoRecording, VideoRecording } from "@app/common/types";

const useRecordingInfoQueries = (
  sessionIds: string[],
  opts: { enabled: boolean } = { enabled: true }
) => {
  const enableQueries = opts.enabled && Hls.isSupported();

  const uniqueSessionIds = uniq(sessionIds);

  const queries = uniqueSessionIds.map((sessionId) => ({
    queryKey: ["recording", sessionId],
    queryFn: () => getRecordingInfo(sessionId),
    enabled: Boolean(sessionId) && enableQueries,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    retry: false,
    retryOnMount: false,
  }));

  const queryResultsBySessionId = new Map<
    string,
    {
      isLoading: boolean;
      recordingInfo?: VideoRecording | UnauthorizedVideoRecording;
    }
  >();
  const queryResults = useQueries({ queries });

  uniqueSessionIds.forEach((sessionId, i) => {
    const result = queryResults[i];
    const opts = {
      isLoading: result.isInitialLoading,
      recordingInfo: result?.data,
    };
    queryResultsBySessionId.set(sessionId, opts);
  });

  return queryResultsBySessionId;
};

export default useRecordingInfoQueries;
